<template>
  <section class="flex flex-col">
    <div class="flex flex-col max-w-320 md:max-w-none justify-between">
      <h3 class="text-h3 mb-4">What parents will see</h3>
      <p class="mb-4">Here’s some Adventures examples to show you how it’ll look</p>
    </div>
    <div
      class="relative min-h-240 lg:w-664 overflow-x-scroll hide-scrollbar lg:overflow-x-hidden mb-12 md:mb-20 lg:mb-16 pt-16 pb-24 px-4 lg:px-0"
    >
      <ul class="flex absolute gap-16 lg:gap-3">
        <li
          v-for="(adventure, index) in exampleAdventures"
          :key="index"
          class="w-[212px]"
          :class="index > 2 ? 'lg:hidden' : undefined"
        >
          <ComplexCard
            class="!w-full"
            variant="small"
            :headerImageUrl="adventure.adventureCategoryImage.url"
            :title="adventure.title"
            :firstLineText="firstLineText(adventure.ageRangeText)"
            :minPayRate="adventure.minPayRate"
            :maxPayRate="adventure.maxPayRate"
            :detailsUrl="adventureDetailsUrl(adventure.sitterLocation, adventure.title)"
          />
        </li>
      </ul>
    </div>
  </section>
</template>

<script lang="ts">
import ComplexCard from '@/components/complex_card/ComplexCard.vue';
import { exampleAdventures } from '@/helpers/exampleAdventures';
import adventures from '@/lib/adventures';

export default {
  name: 'WhatParentsWillSee',
  components: { ComplexCard },
  data(): any {
    return {
      exampleAdventures,
    };
  },
  computed: {
    isSitter() {
      return {
        isSitter: () => true,
      };
    },
  },
  methods: {
    adventureDetailsUrl(adventureLocation, unformattedAdventureId): string | null {
      const adventureId = unformattedAdventureId.toLowerCase().split(' ').join('-');
      return adventures.getAdventureDetailsUrl(adventureLocation, adventureId);
    },
    firstLineText(ageRange): string | null {
      return adventures.getFirstLineText('small', ageRange);
    },
  },
};
</script>
